// extracted by mini-css-extract-plugin
export default {"search-table":"user_search-table__UkdK-","avatar":"user_avatar__l--zI","upload-avatar":"user_upload-avatar__qwYKi"};